var wrappers = require('./dist-modules/hooks.js');

exports.useRoot = wrappers.useRoot;
exports.useBranch = wrappers.useBranch;